import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import grid from './Grid.module.scss';

export default function Grid(props) {
  const {
    justify = 'start',
    align = 'top',
    mode = 'row',
    className,
    gutter = 0,
    style,
    children,
    prefix = 'datalab-grid-row',
    ...others
  } = { ...props };

  const classes = cx(
    grid[`${prefix}`],
    {
      [grid[`${prefix}-${justify}`]]: justify,
      [grid[`${prefix}-${align}`]]: align,
      [grid[`${prefix}-column`]]: mode === 'column',
    },
    className,
  );

  const rowStyle =
    gutter > 0
      ? {
          marginLeft: gutter / -2,
          marginRight: gutter / -2,
          marginTop: gutter / -2,
          marginBottom: gutter / -2,
          ...style,
        }
      : style;

  const cols = React.Children.map(children, (col) => {
    if (!col) {
      return null;
    }
    if (col.props && gutter > 0) {
      return React.cloneElement(col, {
        style: {
          paddingLeft: gutter / 2,
          paddingRight: gutter / 2,
          paddingTop: gutter / 2,
          paddingBottom: gutter / 2,
          ...col.props.style,
        },
      });
    }
    return col;
  });

  return (
    <div {...others} className={classes} style={rowStyle}>
      {cols}
    </div>
  );
}

Grid.propTypes = {
  align: PropTypes.oneOf(['top', 'bottom', 'middle', 'stretch']),
  justify: PropTypes.oneOf([
    'start',
    'center',
    'end',
    'space-between',
    'space-around',
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
  gutter: PropTypes.number,
  prefix: PropTypes.string,
  style: PropTypes.object,
  mode: PropTypes.oneOf(['row', 'column']),
};
